export const getRandomQuote = async () => {
  try {
    // Simple GET request without additional headers
    const response = await fetch('https://get-quote-69957198502.asia-east1.run.app/?interval=3');
    
    // Parse the JSON response
    const quote = await response.json();
    
    // Format the quote with author and title
    return `${quote.text}<br> －${quote.author} ${quote.title}`;
  } catch (error) {
    console.log('Error fetching quote:', error);
    return '馬上就好，請稍候片刻...';
  }
};
